<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'sm', // opções: sm, md, lg, full
        validator: (v) => ['sm', 'md', 'lg', 'full'].includes(v)
    },
    next: {
        type: Boolean,
    }
})

const router = useRouter()

const sizeClasses = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-5 py-3 text-lg',
    full: 'w-100 py-2'
}
</script>

<template>
    <v-btn
        type="button"
        :loading="loading"
        class="btn btn-outline-primary mb-3 d-flex align-items-center justify-center"
        :class="sizeClasses[size]"
        variant="tonal"
    >
        <i v-if="!next" class="material-symbols-outlined mr-2">arrow_back</i>
        {{ (next ? $t('common.labels.next') : $t('common.labels.previous')) }}
        <i v-if="next" class="material-symbols-outlined mr-2">arrow_forward</i>
    </v-btn>
</template>
